type UseBdApp = {
  isMobile: boolean
  isAndroid: boolean
  isIos: boolean
  isNative: boolean
}

const BD_APP_NATIVE_KEY = 'bdApp.forceNative'

export function setBdAppNative(isNative: boolean): void {
  if (isNative) {
    localStorage.setItem(BD_APP_NATIVE_KEY, 'true')
  } else {
    localStorage.removeItem(BD_APP_NATIVE_KEY)
  }
}

export function getBdAppNative(): boolean | null {
  const stored = localStorage.getItem(BD_APP_NATIVE_KEY)
  return stored === 'true' ? true : null
}

export function checkBdApp(): UseBdApp {
  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  const isAndroid = /Android/i.test(navigator.userAgent)
  const isIos = /iPhone|iPad|iPod/i.test(navigator.userAgent)

  // Check localStorage first, then fall back to user agent detection
  const storedNative = getBdAppNative()
  const isNative =
    storedNative !== null ? storedNative : /bdApp/i.test(navigator.userAgent)

  return {
    isNative,
    isMobile,
    isAndroid,
    isIos,
  }
}

export default function useBdApp(): UseBdApp {
  return checkBdApp()
}
